import { Box, Grid, Tab, Tabs, styled, useTheme } from "@mui/material";
import { Ico_Warning } from "@sagecentral/core-ui";
import { IMetadataTab } from "models/metadata";
import { useMemo } from "react";

type TabProps = {
    value: string;
    text?: string;
    selected?: boolean;
    hasAlert?: boolean;
};

type MetadataTabProps = {
    tabs: IMetadataTab[];
    selectedValue: string;
    setSelectedValue: React.Dispatch<React.SetStateAction<string>>;
    checkAlert: (group: IMetadataTab) => boolean;
};

const MetadataTabsOuter = styled(Box)({
    width: '100%',
    marginBottom: '20px',
    paddingTop: '10px'
});

const MetadataGridOuter = styled(Grid)({
    alignItems: 'flex-end'
});

const MetadataTabsDivider = styled(Box)(({ theme }) => ({
    borderBottom: '1px solid',
    borderColor: theme.palette.divider,
    marginTop: '-2px'
}));

const MetadataLinkTabStyle = styled(Tab)(({ theme }) => ({
    paddingLeft: '20px',
    paddingRight: '20px',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '22px',
    color: '#333333',
    textTransform: 'capitalize',
    textDecoration: 'none',

    '&.active': {
        color: theme.palette.secondary.main,
        fontWeight: 600
    }
}));

const MetadataTabsStyle = styled(Tabs)({
    color: '#333333',
    '& .MuiTabs-indicator': {
        color: '#001A69',
        backgroundColor: '#001A69',
        height: '1px',
        borderRadius: '4px',
    }
});

const LinkTab = (props: TabProps) => {
    const {
        text,
        selected,
        hasAlert
    } = props;

    const theme = useTheme();

    return (
        <MetadataLinkTabStyle
            label={text}
            className={selected ? 'active' : ''}
            icon={
                hasAlert ? <Ico_Warning
                    sx={{
                        width: '20px'
                    }}
                    htmlColor={theme.palette.error.main}
                /> : <></>
            }
            iconPosition='end'
            {...props}
        />
    )
};

const MetadataTabs = (props: MetadataTabProps) => {
    const {
        tabs,
        selectedValue,
        setSelectedValue,
        checkAlert
    } = props;

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setSelectedValue(newValue);
    };


    return (
        <MetadataTabsOuter>
            <MetadataGridOuter>
                <MetadataTabsStyle
                    aria-label='tasks tabs'
                    variant='scrollable'
                    value={selectedValue}
                    onChange={handleChange}
                >
                    {tabs.map((tab, _index) => (
                        <LinkTab
                            key={tab.key}
                            value={tab.key}
                            selected={tab.key === selectedValue}
                            text={tab.name}
                            hasAlert={checkAlert(tab)}
                        />
                    ))}
                </MetadataTabsStyle>
            </MetadataGridOuter>
            <MetadataTabsDivider />
        </MetadataTabsOuter>
    )
};

export default MetadataTabs;